export default defineNuxtPlugin(async (nuxtApp) => {
  // const fp = await window.FingerprintJS.load()
  // nuxtApp.provide('agent', fp)
})
